import { useMemo, useState } from 'react';
import {
  Box,
  ClickAwayListener,
  InputBase,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
} from '@mui/material';
import debounce from 'lodash.debounce';
import SearchIcon from '@mui/icons-material/Search';
import { gqlClient } from 'utils/gqlClient';
import { useSearchProductsQuery } from 'utils/graphql-generated';
import { useTranslation } from 'next-i18next';

const ProductSearch = () => {
  const { t } = useTranslation('common');

  const [searchTerm, setSearchTerm] = useState('');
  const { isLoading, isError, data, error } = useSearchProductsQuery(
    gqlClient,
    { search_term: searchTerm, limit: 5 },
    { enabled: searchTerm.length > 2 }
  );

  const handleChange = (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    setSearchTerm(event.target.value);
  };

  const handleClickAway = () => {
    setSearchTerm('');
  };

  const debounceHandleChange = useMemo(() => {
    return debounce(handleChange, 300);
  }, []);

  return (
    <Box
      sx={{
        paddingBottom: { xs: 2 },
        paddingY: { xs: 1 },
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          flex: 1,
          background: 'white',
          alignItems: 'center',
          justifyContent: 'center',
          maxHeight: 32,
          maxWidth: 700,
          borderRadius: 1,
        }}
      >
        <Box
          sx={{
            minWidth: 280,
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <SearchIcon sx={{ color: 'black', pl: 1 }} />
          <InputBase
            sx={{ flex: 1, color: 'black', pl: 1 }}
            placeholder={t('navbar.productSearch.placeholder')}
            inputProps={{ 'aria-label': 'search' }}
            onChange={debounceHandleChange}
          />
        </Box>
        <Box sx={{ mt: 1 }}>
          <ClickAwayListener onClickAway={handleClickAway}>
            <List
              sx={{
                width: '100%',
                borderRadius: 1,
                boxShadow: 2,
                bgcolor: 'white',
                color: 'black',
                paddingY: 0,
              }}
            >
              {(data?.product || []).length === 0 && searchTerm.length > 2 && (
                <ListItem
                  disablePadding
                  sx={{ borderBottom: 0.5, borderColor: '#cccccc' }}
                >
                  <ListItemButton>
                    <ListItemText>
                      {t('navbar.productSearch.noResult')}
                    </ListItemText>
                  </ListItemButton>
                </ListItem>
              )}
              {(data?.product || []).length > 0 &&
                data?.product?.map(
                  (item) =>
                    (item?.product_details || []).length > 0 && (
                      <ListItem
                        key={`${item!.id}`}
                        disablePadding
                        sx={{ borderBottom: 0.5, borderColor: '#cccccc' }}
                      >
                        <ListItemButton
                          onClick={() =>
                            window.open(
                              `/verkaufen/handys/apple/${
                                (item?.product_details || [])[0]?.id
                              }`,
                              '_self'
                            )
                          }
                        >
                          <ListItemText>{item?.name}</ListItemText>
                        </ListItemButton>
                      </ListItem>
                    )
                )}
            </List>
          </ClickAwayListener>
        </Box>
      </Box>
    </Box>
  );
};

export default ProductSearch;
